import script from "./OfOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./OfOverview.vue?vue&type=script&setup=true&lang=js"

import "./OfOverview.vue?vue&type=style&index=0&id=e7db98ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7db98ce"]])

export default __exports__